import React, { useState } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Users, ShieldCheck, MapPin } from 'lucide-react';
import WmsUsuarios from './WmsUsuarios';
import UserProfile from '../../components/UserProfile';
import ClientesManagement from '../../components/wms/ClientesManagement';

const WmsConfiguracion = () => {
  const [activeItem, setActiveItem] = useState('configuracion');
  const [activeTab, setActiveTab] = useState('account');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Obtener el rol del usuario
  const userRole = localStorage.getItem('role');
  // Si el rol es un array serializado, tomar el primero (o puedes adaptar a múltiples roles)
  let isAdmin = false;
  try {
    const parsed = userRole ? JSON.parse(userRole) : [];
    isAdmin = Array.isArray(parsed) ? parsed.includes('admin') : userRole === 'admin';
  } catch {
    isAdmin = userRole === 'admin';
  }

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <div className="container mx-auto px-4 py-8">
          <Card className="mb-6">
            <CardHeader className="flex flex-row items-center justify-between">
              <div>
                <CardTitle className="text-2xl font-bold">Configuración WMS</CardTitle>
                <CardDescription>Administra tu cuenta y la configuración del sistema WMS</CardDescription>
              </div>
            </CardHeader>
          </Card>
          <Tabs defaultValue={activeTab} value={activeTab} onValueChange={setActiveTab}>
            <TabsList className={`grid grid-cols-1 md:grid-cols-${isAdmin ? 5 : 1} gap-4 mb-6`}>
              <TabsTrigger value="account" className="flex items-center gap-2">
                <UserProfileIcon className="h-4 w-4" /> Mi Cuenta
              </TabsTrigger>
              {isAdmin && (
                <>
                  <TabsTrigger value="users" className="flex items-center gap-2">
                    <Users className="h-4 w-4" /> Administración de Usuarios
                  </TabsTrigger>
                  <TabsTrigger value="roles" className="flex items-center gap-2">
                    <ShieldCheck className="h-4 w-4" /> Roles y Permisos
                  </TabsTrigger>
                  <TabsTrigger value="locations" className="flex items-center gap-2">
                    <MapPin className="h-4 w-4" /> Ubicaciones
                  </TabsTrigger>
                  <TabsTrigger value="clientes" className="flex items-center gap-2">
                    <Users className="h-4 w-4" /> Clientes
                  </TabsTrigger>
                </>
              )}
            </TabsList>
            <div className="bg-white rounded-lg shadow-md p-6">
              <TabsContent value="account">
                <UserProfile />
              </TabsContent>
              {isAdmin && (
                <>
                  <TabsContent value="users">
                    <WmsUsuarios />
                  </TabsContent>
                  <TabsContent value="roles">
                    <h2 className="text-xl font-semibold mb-6">Gestión de Roles y Permisos</h2>
                    <div className="text-gray-500">(Próximamente: aquí podrás gestionar los roles y permisos de WMS)</div>
                  </TabsContent>
                  <TabsContent value="locations">
                    <h2 className="text-xl font-semibold mb-6">Gestión de Ubicaciones</h2>
                    <div className="text-gray-500">(Próximamente: aquí podrás gestionar las ubicaciones de WMS)</div>
                  </TabsContent>
                  <TabsContent value="clientes">
                    <ClientesManagement />
                  </TabsContent>
                </>
              )}
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

// Icono para la pestaña Mi Cuenta
const UserProfileIcon = (props) => (
  <svg {...props} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-7 8-7s8 3 8 7"/></svg>
);

export default WmsConfiguracion;
